import React, { useState, useCallback } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Donation Form Component
const DonationForm = React.memo(({ 
  donationAmount,
  setDonationAmount,
  selectedCharity,
  setSelectedCharity,
  donorName,
  setDonorName,
  message,
  setMessage,
  handleDonate,
  resetFlow
}) => {
  console.log("DonationForm rendered");
  return (
    <div className="h-96 bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 flex flex-col relative overflow-hidden">
    {/* Background Pattern */}
    <div 
      className="absolute inset-0 opacity-30"
      style={{
        backgroundImage: `url('/assets/donate.avif')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    ></div>
    <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-32 h-32 border-2 border-yellow-400 rounded-full opacity-30"></div>
        <div className="absolute top-20 right-20 w-24 h-24 border-2 border-yellow-400 rounded-full opacity-20"></div>
        <div className="absolute bottom-20 left-20 w-20 h-20 border-2 border-yellow-400 rounded-full opacity-25"></div>
        <div className="absolute bottom-10 right-10 w-16 h-16 border-2 border-yellow-400 rounded-full opacity-30"></div>
        
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 600">
          <path d="M80 80 Q200 150 320 120" stroke="#fbbf24" strokeWidth="2" fill="none" strokeDasharray="5,5" opacity="0.3"/>
          <path d="M80 400 Q200 350 320 380" stroke="#fbbf24" strokeWidth="2" fill="none" strokeDasharray="5,5" opacity="0.3"/>
          <path d="M80 80 Q150 300 80 400" stroke="#fbbf24" strokeWidth="2" fill="none" strokeDasharray="5,5" opacity="0.2"/>
          <path d="M320 120 Q250 250 320 380" stroke="#fbbf24" strokeWidth="2" fill="none" strokeDasharray="5,5" opacity="0.2"/>
        </svg>
      </div>
      <div className="relative z-10 pt-1 pb-1 px-6">
        <div className="flex items-center justify-between mb-1">
          <button 
            onClick={resetFlow}
            className="text-white text-xl w-8 h-8 flex items-center justify-center"
          >
            ❮
          </button>
          <div className="text-center">
            <h1 className="text-white text-lg font-bold">DONATE WITH BRI! </h1>
            {/* <div className="text-2xl">💰</div> */}
          </div>
          <div className="w-4"></div>
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center px-6 relative z-10">
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-3 border border-white/20 max-w-sm w-full">
          <div className="space-y-1">
            <div>
              <label className="text-white text-sm font-semibold  block">Enter Amount:</label>
              <div className="relative">
                <span className="absolute left-3 top-1 text-gray-600 font-medium">IDR</span>
                <input
                  type="text"
                  inputMode="numeric"
                  value={donationAmount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) setDonationAmount(value);
                  }}
                  className="w-full pl-12 pr-4 py-1 rounded-xl bg-white/90 border border-white/30 text-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                  placeholder="Amount to donate"
                />
              </div>
              <div className="flex gap-2 mt-1">
                {['50000', '100000','250000'].map((amount) => (
                  <button
                    key={amount}
                    onClick={() => setDonationAmount(amount)}
                    className="bg-white/20 text-white text-xs px-1 py-1 rounded-lg hover:bg-white/30 transition-colors"
                  >
                    {parseInt(amount).toLocaleString()}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="text-white text-sm font-semibold  block">Choose Charity:</label>
              <select
                value={selectedCharity}
                onChange={(e) => setSelectedCharity(e.target.value)}
                className="w-full px-4 py-1 rounded-xl bg-white/90 border border-white/30 text-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              >
                <option value="">Select a charity</option>
                <option value="education">Education Foundation</option>
                <option value="healthcare">Healthcare Support</option>
                <option value="disaster">Disaster Relief</option>
                <option value="poverty">Poverty Alleviation</option>
                <option value="orphanage">Orphanage Support</option>
                <option value="environment">Environmental Conservation</option>
              </select>
            </div>

            <div>
              <label className="text-white text-sm font-semibold block">Your Name (Optional):</label>
              <input
                type="text"
                value={donorName}
                onChange={(e) => setDonorName(e.target.value)}
                className="w-full px-4 py-1 rounded-xl bg-white/90 border border-white/30 text-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                placeholder="Enter your name"
              />
            </div>

            {/* <div>
              <label className="text-white text-sm font-semibold mb-1 block">Message (Optional):</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full px-4 py-1 rounded-xl bg-white/90 border border-white/30 text-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400 resize-none"
                placeholder="Leave a message..."
                rows="3"
              />
            </div> */}

            <button
              onClick={handleDonate}
              disabled={!donationAmount || !selectedCharity}
              className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed text-black font-bold py-1 px-1 rounded-xl shadow-md transform hover:scale-105 disabled:hover:scale-100 transition-all duration-200 text-sm w-full"
            >
              DONATE NOW 
            </button>

            <div className="text-center mt-1">
              <p className="text-white/70 text-xs">
                Seamless donations to verified charities from your BRI Bank account
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="relative z-10 pb-10 px-6 mt-1">
        <div className="flex items-center justify-center">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2 border border-white/20">
            <div className="text-yellow-400 font-bold text-sm">🏛️ BANK BRI</div>
          </div>
        </div>
      </div> */}
    </div>
  );
});

// Donation Flow Component
const DonationFlow = ({ isDesktop = false }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [donationAmount, setDonationAmount] = useState('');
  const [selectedCharity, setSelectedCharity] = useState('');
  const [donorName, setDonorName] = useState('');
  const [message, setMessage] = useState('');

  const handleClickHere = () => setCurrentStep(2);

  const handleDonate = useCallback(() => {
    if (donationAmount && selectedCharity) {
      setCurrentStep(3);
    }
  }, [donationAmount, selectedCharity]);

  const resetFlow = () => {
    setCurrentStep(1);
    setDonationAmount('');
    setSelectedCharity('');
    setDonorName('');
    setMessage('');
  };

  const backToDonation = () => setCurrentStep(2);

  const getCharityDisplayName = (charity) => {
    const charityNames = {
      'education': 'Education Foundation',
      'healthcare': 'Healthcare Support',
      'disaster': 'Disaster Relief',
      'poverty': 'Poverty Alleviation',
      'orphanage': 'Orphanage Support',
      'environment': 'Environmental Conservation'
    };
    return charityNames[charity] || charity;
  };

  const LandingScreen = () => (
    <div className="h-96 bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 flex flex-col relative overflow-hidden">
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url('/assets/donate.avif')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></div>

      {/* Header */}
      <div className="relative z-10 pt-2 pb-1 px-6">
        <div className="text-center mb-1">
          <h1 className="text-white text-2xl font-bold mb-1 font-serif">DONATE WITH BRI!</h1>
          
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 relative z-10">
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-2 border border-white/20 max-w-xs w-full text-center">
          <div className="mb-1">
            <h2 className="text-white text-md font-bold mb-1 font-serif">SEAMLESS DONATIONS TO VERIFIED CHARITIES FROM YOUR BRI BANK ACCOUNT</h2>
          </div>
          
          {/* Click Here Button */}
          <button 
            onClick={handleClickHere}
            className=" font-serif bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black font-bold py-2 px-6 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 text-lg w-full mb-6"
          >
            Click here! 👆
          </button>

          {/* BRI Bank Logo */}
          {/* <div className="flex items-center justify-center space-x-2 font-serif">
            <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center">
              <span className="text-white font-bold text-sm">BRI</span>
            </div>
            <span className="text-white font-bold text-lg">BANK BRI</span>
          </div> */}
        </div>
      </div>

      {/* Bottom Text */}
      <div className="relative z-10 pb-12 px-6 font-serif">
        <p className="text-white/80 text-center text-sm">
          Make a difference today - Do your Part!
        </p>
      </div>
    </div>
  );  

  const ConfirmationScreen = () => (
    <div className="h-96 bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 flex flex-col items-center justify-center px-6 relative overflow-hidden">
    {/* Success Animation */}
    <div 
      className="absolute inset-0 opacity-30"
      style={{
        backgroundImage: `url('/assets/donate.avif')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    ></div>

      <div className="relative z-10 text-center font-serif">
        <div className="text-2xl mb-2">✨</div>
        <h2 className="text-3xl font-bold mb-1 text-white">Thank You!</h2>
        <p className="text-xl text-green-300 mb-1">
          IDR {parseInt(donationAmount).toLocaleString()}
        </p>
        <p className="text-white/80 mb-1">
          Donated to {getCharityDisplayName(selectedCharity)}
        </p>
        
        {donorName && (
          <p className="text-white/80 mb-1">From: {donorName}</p>
        )}
        
        {message && (
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 mb-1 max-w-sm">
            <p className="text-white/90 text-sm italic">"{message}"</p>
          </div>
        )}
        
        <div className="space-y-1">
          <button 
            onClick={backToDonation} 
            className="bg-white/20 hover:bg-white/30 text-white px-6 py-3 rounded-xl font-medium transition-colors w-full max-w-xs"
          >
            Donate Again
          </button>
          <button 
            onClick={resetFlow} 
            className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black px-6 py-3 rounded-xl font-bold transition-all w-full max-w-xs"
          >
            New Donation
          </button>
        </div>

        {/* <div className="mt-4 mb-10 font-serif">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl px-6 py-4 border border-white/20 inline-block">
            <div className="text-yellow-400 font-bold text-lg">🏛️ BANK BRI</div>
          </div>
        </div> */}
      </div>
    </div>
  );

  return (
    <div className="w-full h-full">
      {currentStep === 1 && <LandingScreen />}
      {currentStep === 2 && (
        <DonationForm
          donationAmount={donationAmount}
          setDonationAmount={setDonationAmount}
          selectedCharity={selectedCharity}
          setSelectedCharity={setSelectedCharity}
          donorName={donorName}
          setDonorName={setDonorName}
          message={message}
          setMessage={setMessage}
          handleDonate={handleDonate}
          resetFlow={resetFlow}
        />
      )}
      {currentStep === 3 && <ConfirmationScreen />}
    </div>
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(true);

  return (
    <>
     <Helmet>
       {/* <title>
       Bidbox Ad Gallery | Showcase Targeted Campaign Creativity
        </title>
        <meta
          name="description"
          content="Explore Bidbox’s Ad Gallery – see powerful, targeted ad campaigns in action. Get inspired & elevate your advertising with DSP strategy insights."
        /> */}
        {/* <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/interactive-selector/donation"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-8 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Tap. Choose. Uplift.
                  </h1>
                  <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Interactive Selector
                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-teal-600 mb-4 tracking-wide">
                DRIVE SOCIAL IMPACT
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                This interactive donation flow lets users contribute to verified charities in just a few taps. With multiple causes, sleek design, and smooth payment integration, it's built for platforms aiming to inspire action. Add your branding and partner charities to launch a purpose-driven experience that resonates.
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-teal-600 text-teal-600 px-6 py-3 rounded-full font-medium hover:bg-teal-600 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
                    <div className="flex items-center space-x-3">
                      <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-teal-600' : 'text-gray-600'}`}>
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-teal-600 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:ring-offset-2"
                      >
                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                      </button>
                      <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-teal-600' : 'text-gray-600'}`}>
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>
           
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative bg-gray-200 rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          donate-with-bri.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                        {/* Donation Flow - Full screen on mobile */}
                        <div className="space-y-3">
                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                    <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                    <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                  </div>
                  
                  <div className="mb-6">
                  <div className="relative group transform transition-all duration-300 rounded-lg overflow-hidden">
                          <DonationFlow isDesktop={false} />
                        </div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-4xl mx-auto hidden lg:block">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-2">
                          <div className="bg-white rounded-md px-2 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 donate-with-bri.com
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Browser content area */}
                      <div className="bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                        {/* Donation Flow centered on desktop */}
                        <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>

                          </div>
                        <div className="flex justify-center ">
                          <div className="w-full max-w-md ">
                            <DonationFlow isDesktop={true} />
                          </div>
                        </div>
                         {/* Additional content placeholders */}
                         <div className="grid grid-cols-2 gap-6 mb-6 mt-2">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3 mt-2">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
      `}</style>
    </div>

     <div className="max-w-7xl mx-auto px-4 py-10">
                        <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
                  
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                          {/* Card 1 */}
                          <Link to="/3d-prism/prism" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                            <img
                              src="/assets/prism11.jpg"
                              alt="Card 1"
                              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                              <h2 className="text-lg font-semibold">Prism</h2>
                            </div>
                          </Link>
                  
                          {/* Card 2 */}
                          <Link to="/360rotate/carrotate" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                            <img
                              src="/assets/car121.webp"
                              alt="Card 2"
                              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                              <h2 className="text-lg font-semibold">Car 360</h2>
                            </div>
                          </Link>
                  
                          {/* Card 3 */}
                          <Link to="/hotspot/luxarycloset" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                            <img
                              src="/assets/luxary.webp"
                              alt="Card 3"
                              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                              <h2 className="text-lg font-semibold">Luxary Closet</h2>
                            </div>
                          </Link>
                  
                          {/* Card 4 */}
                          <Link to="/native-display/pepsi" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                            <img
                              src="assets/pepsi.webp"
                              alt="Card 4"
                              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                              <h2 className="text-lg font-semibold">Pepsi</h2>
                            </div>
                          </Link>
                  
                         
                        </div>
                      </div>
    </>
  );
}

export default App;


// import React, { useState, useCallback } from 'react';

// const DonationForm = React.memo(({ 
//   donationAmount,
//   setDonationAmount,
//   selectedCharity,
//   setSelectedCharity,
//   donorName,
//   setDonorName,
//   message,
//   setMessage,
//   handleDonate,
//   resetFlow
// }) => {
//   console.log("DonationForm rendered");
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 flex flex-col relative overflow-hidden">
//     {/* Background Pattern */}
//     <div 
//       className="absolute inset-0 opacity-30"
//       style={{
//         backgroundImage: `url('/assets/donate.avif')`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center'
//       }}
//     ></div>
//     <div className="absolute inset-0 opacity-20">
//         <div className="absolute top-10 left-10 w-32 h-32 border-2 border-yellow-400 rounded-full opacity-30"></div>
//         <div className="absolute top-20 right-20 w-24 h-24 border-2 border-yellow-400 rounded-full opacity-20"></div>
//         <div className="absolute bottom-20 left-20 w-20 h-20 border-2 border-yellow-400 rounded-full opacity-25"></div>
//         <div className="absolute bottom-10 right-10 w-16 h-16 border-2 border-yellow-400 rounded-full opacity-30"></div>
        
//         <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 600">
//           <path d="M80 80 Q200 150 320 120" stroke="#fbbf24" strokeWidth="2" fill="none" strokeDasharray="5,5" opacity="0.3"/>
//           <path d="M80 400 Q200 350 320 380" stroke="#fbbf24" strokeWidth="2" fill="none" strokeDasharray="5,5" opacity="0.3"/>
//           <path d="M80 80 Q150 300 80 400" stroke="#fbbf24" strokeWidth="2" fill="none" strokeDasharray="5,5" opacity="0.2"/>
//           <path d="M320 120 Q250 250 320 380" stroke="#fbbf24" strokeWidth="2" fill="none" strokeDasharray="5,5" opacity="0.2"/>
//         </svg>
//       </div>
//       <div className="relative z-10 pt-10 pb-1 px-6">
//         <div className="flex items-center justify-between mb-2">
//           <button 
//             onClick={resetFlow}
//             className="text-white text-2xl w-8 h-8 flex items-center justify-center"
//           >
//             ❮
//           </button>
//           <div className="text-center">
//             <h1 className="text-white text-xl font-bold">DONATE WITH BRI!</h1>
//             <div className="text-2xl">💰</div>
//           </div>
//           <div className="w-4"></div>
//         </div>
//       </div>
//       <div className="flex-1 flex flex-col items-center justify-center px-6 relative z-10">
//         <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 max-w-sm w-full">
//           <div className="space-y-2">
//             <div>
//               <label className="text-white text-sm font-semibold mb-1 block">Enter Amount:</label>
//               <div className="relative">
//                 <span className="absolute left-3 top-1 text-gray-600 font-medium">IDR</span>
//                 <input
//                   type="text"
//                   inputMode="numeric"
//                   value={donationAmount}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (/^\d*$/.test(value)) setDonationAmount(value);
//                   }}
//                   className="w-full pl-12 pr-4 py-1 rounded-xl bg-white/90 border border-white/30 text-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400"
//                   placeholder="Amount to donate"
//                 />
//               </div>
//               <div className="flex gap-2 mt-1">
//                 {['50000', '100000', '250000'].map((amount) => (
//                   <button
//                     key={amount}
//                     onClick={() => setDonationAmount(amount)}
//                     className="bg-white/20 text-white text-xs px-3 py-1 rounded-lg hover:bg-white/30 transition-colors"
//                   >
//                     {parseInt(amount).toLocaleString()}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div>
//               <label className="text-white text-sm font-semibold mb-1 block">Choose Charity:</label>
//               <select
//                 value={selectedCharity}
//                 onChange={(e) => setSelectedCharity(e.target.value)}
//                 className="w-full px-4 py-1 rounded-xl bg-white/90 border border-white/30 text-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400"
//               >
//                 <option value="">Select a charity</option>
//                 <option value="education">Education Foundation</option>
//                 <option value="healthcare">Healthcare Support</option>
//                 <option value="disaster">Disaster Relief</option>
//                 <option value="poverty">Poverty Alleviation</option>
//                 <option value="orphanage">Orphanage Support</option>
//                 <option value="environment">Environmental Conservation</option>
//               </select>
//             </div>

//             <div>
//               <label className="text-white text-sm font-semibold mb-1 block">Your Name (Optional):</label>
//               <input
//                 type="text"
//                 value={donorName}
//                 onChange={(e) => setDonorName(e.target.value)}
//                 className="w-full px-4 py-1 rounded-xl bg-white/90 border border-white/30 text-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400"
//                 placeholder="Enter your name"
//               />
//             </div>

//             <div>
//               <label className="text-white text-sm font-semibold mb-1 block">Message (Optional):</label>
//               <textarea
//                 value={message}
//                 onChange={(e) => setMessage(e.target.value)}
//                 className="w-full px-4 py-1 rounded-xl bg-white/90 border border-white/30 text-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400 resize-none"
//                 placeholder="Leave a message..."
//                 rows="3"
//               />
//             </div>

//             <button
//               onClick={handleDonate}
//               disabled={!donationAmount || !selectedCharity}
//               className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed text-black font-bold py-1 px-6 rounded-xl shadow-lg transform hover:scale-105 disabled:hover:scale-100 transition-all duration-200 text-lg w-full"
//             >
//               DONATE NOW 💝
//             </button>

//             <div className="text-center mt-1">
//               <p className="text-white/70 text-xs">
//                 Seamless donations to verified charities from your BRI Bank account
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="relative z-10 pb-10 px-6">
//         <div className="flex items-center justify-center">
//           <div className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2 border border-white/20">
//             <div className="text-yellow-400 font-bold text-sm">🏛️ BANK BRI</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// });

// const DonationFlow = ({ isDesktop = false }) => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [donationAmount, setDonationAmount] = useState('');
//   const [selectedCharity, setSelectedCharity] = useState('');
//   const [donorName, setDonorName] = useState('');
//   const [message, setMessage] = useState('');

//   const handleClickHere = () => setCurrentStep(2);

//   const handleDonate = useCallback(() => {
//     if (donationAmount && selectedCharity) {
//       setCurrentStep(3);
//     }
//   }, [donationAmount, selectedCharity]);

//   const resetFlow = () => {
//     setCurrentStep(1);
//     setDonationAmount('');
//     setSelectedCharity('');
//     setDonorName('');
//     setMessage('');
//   };

//   const backToDonation = () => setCurrentStep(2);

//   const getCharityDisplayName = (charity) => {
//     const charityNames = {
//       'education': 'Education Foundation',
//       'healthcare': 'Healthcare Support',
//       'disaster': 'Disaster Relief',
//       'poverty': 'Poverty Alleviation',
//       'orphanage': 'Orphanage Support',
//       'environment': 'Environmental Conservation'
//     };
//     return charityNames[charity] || charity;
//   };

//   const LandingScreen = () => (
//     <div className="min-h-screen bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 flex flex-col relative overflow-hidden">
//       {/* Background Pattern */}

//       <div 
//         className="absolute inset-0 opacity-30"
//         style={{
//           backgroundImage: `url('/assets/donate.avif')`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center'
//         }}
//       ></div>
     

//       {/* Header */}
//       <div className="relative z-10 pt-16 pb-4 px-6">
//         <div className="text-center mb-2">
//           <h1 className="text-white text-3xl font-bold mb-2">DONATE WITH BRI!</h1>
//           <div className="text-6xl mb-4">💰</div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col items-center justify-center px-6 relative z-10">
//         <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 max-w-xs w-full text-center">
//           <div className="mb-6">
//             <h2 className="text-white text-lg font-bold mb-4">SEAMLESS DONATIONS TO VERIFIED CHARITIES FROM YOUR BRI BANK ACCOUNT</h2>
//           </div>
          
//           {/* Click Here Button */}
//           <button 
//             onClick={handleClickHere}
//             className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black font-bold py-3 px-8 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 text-lg w-full mb-6"
//           >
//             Click here! 👆
//           </button>

//           {/* BRI Bank Logo */}
//           <div className="flex items-center justify-center space-x-2">
//             <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center">
//               <span className="text-white font-bold text-sm">BRI</span>
//             </div>
//             <span className="text-white font-bold text-lg">BANK BRI</span>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Text */}
//       <div className="relative z-10 pb-12 px-6">
//         <p className="text-white/80 text-center text-sm">
//           Make a difference today - Do your Part!
//         </p>
//       </div>
//     </div>
//   );  

//   const ConfirmationScreen = () => (
//     <div className="min-h-screen bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 flex flex-col items-center justify-center px-6 relative overflow-hidden">
//     {/* Success Animation */}
//     <div 
//       className="absolute inset-0 opacity-30"
//       style={{
//         backgroundImage: `url('/assets/donate.avif')`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center'
//       }}
//     ></div>

//       <div className="relative z-10 text-center">
//         <div className="text-6xl mb-6">✨</div>
//         <h2 className="text-3xl font-bold mb-4">Thank You!</h2>
//         <p className="text-xl text-green-300 mb-2">
//           IDR {parseInt(donationAmount).toLocaleString()}
//         </p>
//         <p className="text-white/80 mb-6">
//           donated to {getCharityDisplayName(selectedCharity)}
//         </p>
        
//         {donorName && (
//           <p className="text-white/80 mb-2">From: {donorName}</p>
//         )}
        
//         {message && (
//           <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 mb-6 max-w-sm">
//             <p className="text-white/90 text-sm italic">"{message}"</p>
//           </div>
//         )}
        
//         <div className="space-y-3">
//           <button 
//             onClick={backToDonation} 
//             className="bg-white/20 hover:bg-white/30 text-white px-6 py-3 rounded-xl font-medium transition-colors w-full max-w-xs"
//           >
//             Donate Again
//           </button>
//           <button 
//             onClick={resetFlow} 
//             className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black px-6 py-3 rounded-xl font-bold transition-all w-full max-w-xs"
//           >
//             New Donation
//           </button>
//         </div>

//         <div className="mt-12">
//           <div className="bg-white/10 backdrop-blur-sm rounded-xl px-6 py-4 border border-white/20 inline-block">
//             <div className="text-yellow-400 font-bold text-lg">🏛️ BANK BRI</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="w-full h-full">
//       {currentStep === 1 && <LandingScreen />}
//       {currentStep === 2 && (
//         <DonationForm
//           donationAmount={donationAmount}
//           setDonationAmount={setDonationAmount}
//           selectedCharity={selectedCharity}
//           setSelectedCharity={setSelectedCharity}
//           donorName={donorName}
//           setDonorName={setDonorName}
//           message={message}
//           setMessage={setMessage}
//           handleDonate={handleDonate}
//           resetFlow={resetFlow}
//         />
//       )}
//       {currentStep === 3 && <ConfirmationScreen />}
//     </div>
//   );
// };

// const PhoneMockup = () => {
//   return (
//     <div className="relative group">
//       <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-[3rem] p-3 shadow-2xl border border-slate-600 group-hover:shadow-3xl transition-shadow duration-300">
//         <div className="bg-black rounded-[2.5rem] p-1">
//           <div className="w-[300px] h-[670px] bg-white rounded-[2rem] overflow-hidden relative">
//             {/* Status Bar */}
//             <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-black/50 to-transparent z-20 flex justify-between items-center px-6 pt-2">
//               <span className="text-white text-sm font-medium">11:47</span>
//               <div className="flex items-center space-x-1">
//                 <div className="flex space-x-1">
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                 </div>
//                 <span className="text-white text-xs">📶</span>
//                 <span className="text-white text-xs">📱</span>
//                 <span className="text-white text-xs">🔋</span>
//               </div>
//             </div>
            
//             <div className="w-full h-full">
//               <DonationFlow isDesktop={false} />
//             </div>
//           </div>
//         </div>
        
//         {/* Home Indicator */}
//         <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-slate-500 rounded-full"></div>
//       </div>
//     </div>
//   );
// };

// const DesktopMockup = () => {
//   return (
//     <div className="relative group">
//       <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-6 shadow-2xl border border-slate-600 group-hover:shadow-3xl transition-shadow duration-300">
//         <div className="bg-black rounded-xl p-3">
//           <div className="w-[800px] h-[700px] bg-white rounded-lg overflow-hidden relative">
//             {/* Browser Header */}
//             <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-slate-100 to-slate-50 border-b border-slate-200 flex items-center px-6 z-20">
//               <div className="flex space-x-2">
//                 <div className="w-3 h-3 bg-red-500 rounded-full"></div>
//                 <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
//                 <div className="w-3 h-3 bg-green-500 rounded-full"></div>
//               </div>
//               <div className="flex-1 mx-6">
//                 <div className="bg-white rounded-lg px-4 py-2 text-sm text-slate-600 border border-slate-200 shadow-sm">
//                   https://bri.co.id/donate
//                 </div>
//               </div>
//             </div>
            
//             <div className="w-full h-full pt-12">
//               <DonationFlow isDesktop={true} />
//             </div>
//           </div>
//         </div>
        
//         {/* Desktop Stand */}
//         <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-6">
//           <div className="w-40 h-8 bg-gradient-to-b from-slate-600 to-slate-800 rounded-b-xl"></div>
//           <div className="w-56 h-4 bg-gradient-to-b from-slate-700 to-slate-900 rounded-full mx-auto shadow-lg"></div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const ResponsiveDonationFlow = () => {
//   return (
//     <div className="mt-14 min-h-screen bg-gradient-to-br from-slate-100 via-slate-200 to-slate-300 p-8">
//       {/* Header */}
//       <div className="text-center mb-12">
//         <h1 className="text-4xl font-bold text-slate-800 mb-4">BRI Donation Flow</h1>
//         <p className="text-slate-600 text-lg">Seamless donation experience for verified charities</p>
//       </div>
      
//       {/* Mobile View */}
//       <div className="lg:hidden flex items-center justify-center min-h-screen">
//         <div className="text-center space-y-6">
//           <div>
//             <h3 className="text-slate-800 text-2xl font-bold">Mobile Experience</h3>
//             <p className="text-slate-600 text-sm mt-2">Touch-optimized donation flow with BRI banking integration</p>
//           </div>
//           <PhoneMockup />
//         </div>
//       </div>
      
//       {/* Desktop View - Both Mockups */}
//       <div className="hidden lg:flex lg:flex-row lg:space-x-16 lg:items-center lg:justify-center lg:py-12">
//         <div className="flex flex-col items-center space-y-6">
//           <div className="text-center">
//             <h3 className="text-slate-800 text-2xl font-bold">Desktop Experience</h3>
//             <p className="text-slate-600 text-sm mt-2">Full-featured donation platform with BRI integration</p>
//           </div>
//           <DesktopMockup />
//         </div>
        
//         <div className="flex flex-col items-center space-y-6">
//           <div className="text-center">
//             <h3 className="text-slate-800 text-2xl font-bold">Mobile Experience</h3>
//             <p className="text-slate-600 text-sm mt-2">Touch-optimized for mobile devices</p>
//           </div>
//           <PhoneMockup />
//         </div>
//       </div>

//       {/* Flow Description */}
//       <div className="mt-16 max-w-4xl mx-auto bg-white rounded-2xl p-8 shadow-lg">
//         <h2 className="text-2xl font-bold text-slate-800 mb-6">Donation Flow</h2>
//         <div className="grid md:grid-cols-3 gap-6">
//           <div className="text-center">
//             <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
//               <span className="text-2xl">💝</span>
//             </div>
//             <h3 className="font-semibold text-slate-800 mb-2">Step 1: Landing</h3>
//             <p className="text-slate-600 text-sm">Welcome screen with BRI branding and call-to-action</p>
//           </div>
//           <div className="text-center">
//             <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
//               <span className="text-2xl">📋</span>
//             </div>
//             <h3 className="font-semibold text-slate-800 mb-2">Step 2: Donation Form</h3>
//             <p className="text-slate-600 text-sm">Enter amount, select charity, and add optional message</p>
//           </div>
//           <div className="text-center">
//             <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
//               <span className="text-2xl">✨</span>
//             </div>
//             <h3 className="font-semibold text-slate-800 mb-2">Step 3: Success</h3>
//             <p className="text-slate-600 text-sm">Confirmation of successful donation with details</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResponsiveDonationFlow;

